import { useEffect, useState } from 'react';

import keyBy from 'lodash/keyBy';
import sortBy from 'lodash/sortBy';
import uniq from 'lodash/uniq';

import useUserContext from '../../components/contexts/UserData/UserData';

// This hook augments the passed in comments with their authoring users, fetching those users
// from Keycloak (via the Sinatra app) if necessary.
const useCommentsWithUsers = (comments) => {
  const [commentingUsers, setCommentingUsers] = useState(null);

  const { users = [] } = useUserContext();

  const commentUserIDs = uniq(comments?.map(comment => comment.user_id));

  useEffect(() => {
    if (!commentUserIDs || !users) {
      return;
    }
    if (commentUserIDs.length === 0) {
      setCommentingUsers({});
      return;
    }


    setCommentingUsers(keyBy(users, user => user.id));
  }, [users, JSON.stringify(sortBy(commentUserIDs))]); // eslint-disable-line
  // We disable eslint above because it complains about this deep copy check we do with JSON.stringify.

  return {
    data: comments !== null && commentingUsers !== null
      ? comments.map(comment => ({ ...comment, user: commentingUsers[comment.user_id] }))
      : null,
  }
};
export default useCommentsWithUsers;
